import React from 'react'
import { Box, Typography, Button, ListItem, CircularProgress } from '@mui/material'
import { styled } from '@mui/material/styles'
import StatusBlock from './StatusBlock'

export default function DomainListItemExtended({ domain, onVerifyClick, isLoading }) {
  const { domain: name, status } = domain

  return (
    <StyledListItem>
      <Box sx={itemStyles.contentBox}>
        <Typography sx={itemStyles.domainName}>{name}</Typography>
        <StatusBlock status={isLoading ? 'verifying' : status} />
      </Box>
      <Box sx={itemStyles.actionsBox}>
        {status !== 'VERIFIED' && !isLoading && (
          <Button variant='outlined' size='small' onClick={() => onVerifyClick(name)} sx={itemStyles.verifyButton}>
            Verify
          </Button>
        )}
        {isLoading && <CircularProgress size={24} sx={{ mt: 1.5 }} />}
      </Box>
    </StyledListItem>
  )
}

const StyledListItem = styled(ListItem)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  padding: theme.spacing(2),
  marginBottom: theme.spacing(1.5),
  borderRadius: '16px',
  backgroundColor: '#fff',
  border: `1px solid #DBDBE6`
}))

const itemStyles = {
  contentBox: { flexGrow: 1 },
  domainName: { color: '#1B1B26', fontFamily: 'Plus Jakarta Sans', fontWeight: 400, fontSize: '20px' },
  actionsBox: { display: 'flex', flexDirection: 'column', alignItems: 'flex-end', ml: 2, minWidth: '200px' },
  verifyButton: {
    borderRadius: '16px',
    fontFamily: 'Plus Jakarta Sans',
    fontWeight: 400,
    fontSize: '16px',
    backgroundColor: '#0246F8',
    boxShadow: 'none',
    color: '#fff',
    textTransform: 'none',
    width: '120px',
    '&:hover': { backgroundColor: '#1d4ed8' },
    '&.Mui-disabled': {
      backgroundColor: '#e0e0e0',
      color: '#757575'
    }
  }
}
